import { render, staticRenderFns } from "./DataInputGeometry.vue?vue&type=template&id=15c2cca2&"
import script from "./DataInputGeometry.vue?vue&type=script&lang=js&"
export * from "./DataInputGeometry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports